// ---------------------------------------------------------------------------
// seo-product.content.ts — Per-product translated content for SEO product
// landing pages. English text lives in seo-landing.data.ts; this file holds
// non-English locale overrides keyed by product slug.
// ---------------------------------------------------------------------------
import type { SupportedLocale } from '../i18n.config';
import { SEO_PRODUCT_AR } from './seo-product.ar';
import { SEO_PRODUCT_TH } from './seo-product.th';
import { SEO_PRODUCT_ES } from './seo-product.es';
import { SEO_PRODUCT_FR } from './seo-product.fr';
import { SEO_PRODUCT_DE } from './seo-product.de';
import { SEO_PRODUCT_JA } from './seo-product.ja';
import { SEO_PRODUCT_ZH } from './seo-product.zh';
import { SEO_PRODUCT_HI } from './seo-product.hi';

export interface SEOProductText {
  heroTitle: string;
  heroSubtitle: string;
  heroCtaText: string;
  problemTitle: string;
  problemPoints: string[];
  features: Array<{ title: string; description: string }>;
  benefitsTitle: string;
  benefits: Array<{ label: string; description: string }>;
  testimonial: { quote: string; role: string; hotel: string };
  faqItems: Array<{ question: string; answer: string }>;
  ctaTitle: string;
  ctaSubtitle: string;
  relatedPages: Array<{ label: string; description: string }>;
}

export const SEO_PRODUCT_TRANSLATIONS: Partial<Record<SupportedLocale, Record<string, SEOProductText>>> = {
  ar: SEO_PRODUCT_AR,
  th: SEO_PRODUCT_TH,
  es: SEO_PRODUCT_ES,
  fr: SEO_PRODUCT_FR,
  de: SEO_PRODUCT_DE,
  ja: SEO_PRODUCT_JA,
  zh: SEO_PRODUCT_ZH,
  hi: SEO_PRODUCT_HI,
};
